'use strict';

module.exports = {
  id: 'throwOnError',
  after: function after(res) {
    if (!res.ok) {
      throw res;
    }

    return res;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/http-state-source/hooks/throwOnError.js
// module id = 1puF
// module chunks = 88